import { Separator } from '@betterment/samba-react';
import { DrawerListRow } from '@betterment/shared-components/src/components/activity/components/drawer/common/DrawerListRow';

import { ActivityItemFragment } from '../../../../../graphql/fragments/activityItem.generated';
import { NarrowTypename } from '../../../../../graphql/utils/narrow-typename';
import { ActivityDrawerLayout } from '../common/ActivityDrawerLayout';

export const AllocationChange: React.FC<{
  item: NarrowTypename<ActivityItemFragment, 'ActivityItemAllocationChange'>;
}> = ({ item }) => {
  return (
    <ActivityDrawerLayout title="Portfolio Change" users={item.subAccount.users}>
      <DrawerListRow label="Account" value={item.subAccount.legalAccount.displayName ?? ''} />
      <Separator />
      <DrawerListRow label="Change details" value={item.newPortfolioDescription} />
      <Separator />
      <DrawerListRow label="Note" value="—" />
      <Separator />
    </ActivityDrawerLayout>
  );
};
